module.exports = __webpack_public_path__ + "img/dianshiju1.02bb3caa.png";